






import Vue from "vue";
import Component from "vue-class-component";

import NotificationWrapper from "@/components/ui/NotificationWrapper.vue";

@Component({
  components: { NotificationWrapper }
})
export default class App extends Vue {}
